import { useState, ReactNode, ComponentType } from 'react';

import useMount from '@picsart/rc/useMount';

import isServer from 'utils/shared/isServer';

function WithClientWrapper({
  children,
  Wrapper,
}: {
  children: ReactNode | ReactNode[];
  Wrapper: ComponentType<any>;
}) {
  const [isClient, setIsClient] = useState(false);

  useMount(() => {
    setIsClient(!isServer());
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isClient ? <Wrapper>{children}</Wrapper> : <>{children}</>;
}

export default WithClientWrapper;
